export const getLastSortedColumnValue = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastSortedColumnValuePrev;
    case 'next':
      return pagination.lastSortedColumnValueNext;
    default:
      return null;
  }
};

export const getLastTrackingColumnId = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastTrackingRequestIdPrev;
    case 'next':
      return pagination.lastTrackingRequestIdNext;
    default:
      return null;
  }
};

export const getLastTrackingContainerId = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastItemIdPrev;
    case 'next':
      return pagination.lastItemIdNext;
    default:
      return null;
  }
};

export const getLastBiddingColumnId = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastItemIdPrev;
    case 'next':
      return pagination.lastItemIdNext;
    default:
      return null;
  }
};

export const getLastRFQColumnId = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastItemIdPrev;
    case 'next':
      return pagination.lastItemIdNext;
    default:
      return null;
  }
};

export const getLastSortedColumnValueBl = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastSortedColumnValueBlPrev;
    case 'next':
      return pagination.lastSortedColumnValueBlNext;
  }
};

export const getLastSortedColumnValueContainer = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastSortedColumnValueContainerPrev;
    case 'next':
      return pagination.lastSortedColumnValueContainerNext;
    default:
      return null;
  }
};

export const getLastContainerId = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastContainerIdPrev;
    case 'next':
      return pagination.lastContainerIdNext;
    default:
      return null;
  }
};

export const getLastItemId = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastItemIdPrev;
    case 'next':
      return pagination.lastItemIdNext;
    default:
      return null;
  }
};

export const getLastBlId = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastBlIdPrev;
    case 'next':
      return pagination.lastBlIdNext;
  }
};

export const getLastRFQDetailsColumnId = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastItemIdPrev;
    case 'next':
      return pagination.lastItemIdNext;
    default:
      return null;
  }
};

export const getLastRFQBidItemColumnId = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastItemIdPrev;
    case 'next':
      return pagination.lastItemIdNext;
    default:
      return null;
  }
};

export const getLastColumnId = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastItemIdPrev;
    case 'next':
      return pagination.lastItemIdNext;
    default:
      return null;
  }
};

export const getLastRowId = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastRowIdNext;
    case 'next':
      return pagination.lastRowIdPrev;
    default:
      return null;
  }
};
